import React, { useState, useEffect } from 'react'
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import OutlinedInput from '@mui/material/OutlinedInput';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import { Input } from '@mui/material';

const MultiSelect = ({ label, inputData, onChange, value }) => {
    const [selectValue, setSelectValue] = useState('')
    const [listItems, setListItems] = useState([])

    const onChangeHandler = (e) => {
        const {
            target: { value },
        } = e;
        setSelectValue(typeof value === 'string' ? value.split(',') : value)
        onChange(typeof value === 'string' ? value.split(',') : value)
    }

    useEffect(() => {
        setSelectValue(value)
    }, [value])

    useEffect(() => {
        setListItems(inputData)
    }, [inputData])

    return (
        <FormControl fullWidth size="small" variant='standard' >
            <InputLabel id="demo-multiple-chip-label">{label !== undefined ? label : ''}</InputLabel>
            <Select
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                
                value={selectValue !== null ? selectValue : ''}
                onChange={e => onChangeHandler(e)}
                input={<Input   id="select-multiple-chip" label={label !== undefined ? label : ''} />}
                renderValue={(selected) => (
                    listItems.length > 0 ?
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            { selected.map((value, i) => (
                                listItems.filter(x => x.code === value).length > 0 ?
                                    <Chip variant='' key={i} label={listItems.filter(x => x.code === value)[0]['name']} />
                                    : ''
                            ))}
                        </Box>
                        : ""
                )}
            >
                {listItems ? listItems.map((item, i) => (
                    <MenuItem key={i} value={item.code}>
                        <Checkbox checked={selectValue.indexOf(item.code) > -1} />
                        <ListItemText primary={item.name} />
                    </MenuItem>
                )):""}
            </Select>
        </FormControl>
    )
}

export default MultiSelect